module.exports = __webpack_public_path__ + "static/img/samurai-logo.139221b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/samurai-logo.png
// module id = zaIX
// module chunks = 0